<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="title">

        <ul class="tab">
          <li>
            <div @click="scenicListShow = !scenicListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/spot.png" />
              </div>
              <div class="drop-name">{{scenicSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="scenicListShow">
                <li :key="index"
                    @click="scenicSelected = item"
                    v-for="(item, index) in scenicList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li style="width: 20px"></li>

          <li>
            <div @click="dateListShow = !dateListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/time.png" />
              </div>
              <div class="drop-name">{{dateSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="dateListShow">
                <li :key="index"
                    @click="dateSelected = item"
                    v-for="(item, index) in dateList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="sortListShow = !sortListShow" class="expand">
              <div class="icon">
                <img src="../../assets/sort.png" />
              </div>
              <div class="drop-name">{{sortSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="sortListShow">
                <li :key="index"
                    @click="sortSelected = item"
                    v-for="(item, index) in sortList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="typeListShow = !typeListShow" class="expand">
              <div class="icon">
                <img src="../../assets/index/content.png" />
              </div>
              <div class="drop-name">{{typeSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="typeListShow">
                <li :key="index"
                    @click="typeSelected = item"
                    v-for="(item, index) in typeList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <div class="search">
          <input type="text" placeholder="输入关键词搜索" />
          <div class="search-btn"></div>
        </div>
      </div>

      <div class="subTitle" ></div>
      <div>
        <div class="subTitle" >舆情量趋势</div>
        <YuqingbianhuaqushiCP
                id="yuqingbianhuaqushiDetailChart"
                :chartData="yuqingbianhuaqushiData"
                v-if="yuqingbianhuaqushiData"/>
      </div>

      <div>
        <div class="subTitle" >舆情风险度</div>
        <YuqingfengxianduCP
                id="yuqingfengxianduDetailChart"
                :chartData="yuqingfengxianduData"
                :height="containerSizeH"
                :width="containerSizeW"
                v-if="yuqingfengxianduData"/>
      </div>



      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";

import YuqingbianhuaqushiCP from "@/components/Lvyouyulun/Yuqingbianhuaqushi.vue";
import YuqingfengxianduCP from "@/components/Lvyouyulun/Yuqingfengxiandu.vue";

export default {
  name: "YuqingliangqushiDetail",
  components: {
    ChildModal,
    YuqingbianhuaqushiCP,
    YuqingfengxianduCP
  },
  props: {},
  data() {
    return {
      yuqingbianhuaqushiData: null,
      yuqingfengxianduData: null,
      yuqingfengxianduW: 300,
      yuqingfengxianduH: 300,

      scenicSelected: "黄山",
      scenicListShow: false,
      scenicList: ["黄山","泰山","衡山"],

      dateSelected: "一周内",
      dateListShow: false,
      dateList: ["一周内","一月内","三月内","一年内"],

      sortSelected: "时间",
      sortListShow: false,
      sortList: ["时间","热度"],

      typeSelected: "综合",
      typeListShow: false,
      typeList: ["综合","新闻资讯","论坛","贴吧","博客","微博","微信","OTA","视频","问答"],
    };
  },
  computed: {
    containerSizeW: function() {
      return this.yuqingfengxianduW + "px"

    },containerSizeH: function() {
      return this.yuqingfengxianduH + "px"
    }
  },
  mounted() {
    // 舆情变化趋势
    fetch("/data/Lvyouyulun/Yuqingbianhuaqushi.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.yuqingbianhuaqushiData = json.data;
        });
    // 舆情风险度
    fetch("/data/Lvyouyulun/Yuqingfengxiandu.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.yuqingfengxianduData = json.data;
        });
  },
  methods: {}
};
</script>

<style scoped lang="less">
  .subTitle {
    height: 0.5rem;
    font-size: 0.2rem;
    color: #00cdf9;
    font-weight: bold;
    text-align: center;
  }
  .title {
    height: 0.5rem;
    font-size: 0.18rem;
    color: #00cdf9;
    font-weight: bold;
    float: left;
    .tab {
      /*width: 3.5rem;*/
      /*height: 0.3rem;*/
      /*margin: 0 auto 0.16rem;*/

      > li {
        width: 1.5rem;
        height: 0.34rem;
        line-height: 0.3rem;
        float: left;
        color: @base-text-color;
        cursor: pointer;
        > div {
          float: left;
        }
        .expand {
          /*width: 1.5rem;*/
          height: 0.3rem;
          position: absolute;
          cursor: pointer;
          > div {
            float: left;
            /*width: 0.3rem;*/
            height: 0.3rem;
            line-height: 0.3rem;
          }
          .local {
            width: 0.3rem;
            background: url(../../assets/youkexianxiaxingweifenxi/local.png);
            background-size: 100% 100%;
          }
          .arrow {
            width: 30px;
            height: 0.3rem;
            background: url(../../assets/header_menu/arrow.png);
            background-size: 100% 100%;
          }
          .icon {
            width: 30px;
            height: 30px;
            margin-top: -5px;
          }
          .drop-list {
            z-index: 9999;
            position: absolute;
            left: 0;
            top: 0.3rem;
            width: 100%;
            background: #052148;
            border: 1px solid #00cdff;
            padding: 0.05rem 0;
            box-sizing: border-box;
            li:hover {
              background: #0c3964;
            }
          }
        }
      }
    }
  }
  .search {
    width: 2.3rem;
    height: 0.26rem;
    position: absolute;
    top: 0.34rem;
    right: 0.3rem;
    input {
      width: 2.02rem;
      height: 0.26rem;
      background: #0e264b;
      border: 0.02rem solid #07779e;
      outline: none;
      float: left;
      padding-left: 0.1rem;
      color: #fff;
    }
    .search-btn {
      width: 0.26rem;
      height: 0.26rem;
      float: right;
      background: rgba(0, 0, 0, 0.5) url(../../assets/spot_search_btn.jpg);
      background-size: 100% 100%;
      cursor: pointer;
    }
    input::-webkit-input-placeholder {
      color: #ccc;
    }
  }
</style>
